"use strict";

module.exports.HttpLogger = require('./HttpLogger');